import { AxiosResponse } from 'axios'
import { http } from 'http/index'
import ApiService from 'services/api'
import { IFlagConfig, ITypeConfig, IUnleashFlagConfig } from './type'

export class ConfigInfoService extends ApiService {
  getConfigInfo(): Promise<AxiosResponse<ITypeConfig>> {
    return http.get(`/admin/config`)
  }

  getInfoFlag(configurationKey: string): Promise<AxiosResponse<IFlagConfig>> {
    return http.get(`/admin/flag-configuration/${configurationKey}`)
  }
  getUnleashFlag(
    configurationKey: string
  ): Promise<AxiosResponse<IUnleashFlagConfig>> {
    return http.get(`/admin/get-unleash-flag?flagKey=${configurationKey}`)
  }
}
// eslint-disable-next-line
export default new ConfigInfoService()
